// Footer.tsx
import { PhoneIcon, EnvelopeIcon, MapPinIcon } from "@heroicons/react/24/outline";

export default function Footer() {
  return (
    <footer className="mt-0 border-t border-gray-200 pt-0 pb-0">
      <div className="flex flex-col sm:flex-row sm:justify-around gap-6 text-gray-700 text-sm">

        {/* Phone */}
        <a
          href="tel:+33766279148"
          className="flex items-center space-x-2 hover:opacity-80 transition"
        >
          <PhoneIcon className="w-6 h-6 text-[#d8bd80]" />
          <span className="font-medium text-gray-800">+33 7 66 37 15 12</span>
        </a>

        {/* Email */}
        <a
          href="mailto:info@chateau-depierre.com"
          className="flex items-center space-x-2 hover:opacity-80 transition"
        >
          <EnvelopeIcon className="w-6 h-6 text-[#d8bd80]" />
          <span className="font-medium text-gray-800">info@chateau-depierre.com</span>
        </a>

        {/* Location */}
        <a
          href="https://www.chateau-depierre.com/about-roanne"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 hover:opacity-80 transition"
        >
          <MapPinIcon className="w-6 h-6 text-[#d8bd80]" />
          <span className="font-medium text-gray-800">Roanne, France</span>
        </a>

      </div>
    </footer>
  );
}
